import * as React from 'react';

import { useSelector } from 'react-redux';

import { ActionAfterViewed } from '@cian/action-after-viewed-component';

import { NBSP } from '../../constants/symbols';

import { ContentSection } from '../../components/ContentSection';
import { ChartOffersViewedContainer } from '../Charts';
import { DynamicInfo } from '../../components/DynamicInfo';
import { getChartsData } from '../../selectors';
import { EBlockInPageName } from '../../types/share';
import { trackBlockInPageViewed } from '../../tracking';
import { ACTION_AFTER_VIEWED_TIMEOUT } from '../../constants/actionAfterViewed';

export function ContentOffersViewedContainer() {
  const chartData = useSelector(getChartsData('demand'));

  const trackViewed = React.useCallback(() => {
    trackBlockInPageViewed(EBlockInPageName.Demand);
  }, []);

  if (chartData && chartData.block) {
    return (
      <ActionAfterViewed callback={trackViewed} timeoutCallback={ACTION_AFTER_VIEWED_TIMEOUT}>
        <ContentSection
          title="Спрос на жилье"
          description={`Спрос — количество запросов на${NBSP}поиск недвижимости на${NBSP}рынке по оценке Циан. За${NBSP}100% принято количество запросов в${NBSP}январе${NBSP}2020`}
          mainContent={<DynamicInfo trend={chartData.block.trend} title={chartData.block.title} />}
          chart={<ChartOffersViewedContainer />}
        />
      </ActionAfterViewed>
    );
  }

  return null;
}
